import { AgentApiRequestHelper } from '../agent-api-request-helper';
import type { CommendaAiMutationResult } from '../types';
import type { IDocumentReaderPaperViewUrlResponse } from './types';

/** Asks for a fresh 10-minute link to one paper by its chat reference (`C:<fileId>` or `D:<runId>:<documentKey>`).
 * Asked on click, so no long-lived link is ever kept in the chat history. */
export async function getDocumentReaderPaperViewUrl(
  documentRef: string
): Promise<CommendaAiMutationResult<IDocumentReaderPaperViewUrlResponse>> {
  return AgentApiRequestHelper.mutate<IDocumentReaderPaperViewUrlResponse>(
    `agent-platform/document-reader/papers/view-url?ref=${encodeURIComponent(documentRef)}`,
    { method: 'GET' },
    'Could not open this document.'
  );
}
